<script>
	import { t, locale } from '$lib/translations';
	import Article from "/src/components/ui/Article.svelte";
	import SortingImage from "$lib/images/sorting.svg"
	import SearchImage from "$lib/images/search.svg"
	import Check from "$lib/images/check.svg"
	import { onMount } from 'svelte';

	export let data;

	const articles = data.articles;

	let activeCategory = 0;
	let activeFilter = 0;
	let searchQuery = "";
	let categories = [{ id: 0, name: $t('news.all'), type: "news" }, ...data.categories];

	// Реактивное выражение для фильтрации статей по языку
	$: filterByLocale = articles.filter(article => article.lang === $locale);

	// Реактивное выражение для применения фильтров
	$: sortedArticles = (() => {
		let filteredArticles = filterByLocale;

		// Применяем фильтрацию по категории
		if (activeCategory !== 0) {
			filteredArticles = filteredArticles.filter(article => article.category_id === activeCategory);
		}

		// Применяем поиск по запросу
		if (searchQuery) {
			const query = searchQuery.toLowerCase();
			filteredArticles = filteredArticles.filter(article =>
					article.title.toLowerCase().includes(query) ||
					article.short_description.toLowerCase().includes(query) ||
					article.text.toLowerCase().includes(query)
			);
		}

		// Сортировка по дате
		if (activeFilter === 0) {
			return filteredArticles.sort((a, b) => b._id - a._id);
		} else {
			return filteredArticles.sort((a, b) => a._id - b._id);
		}
	})();

	// Функция для обновления категории
	const filterButton = (index) => {
		activeCategory = index;
	};

	let sortingMenu = false;
	let mouseButton = false;
	let mouseMenu = false;
	let hideTimeout;

	const openMenu = () => {
		sortingMenu = true;
	}

	const onButtonMouseEnter = () => {
		mouseButton = true;
		openMenu();
	}

	const closeMenu = () => {
		hideTimeout = setTimeout(() => {
			if (!mouseButton && !mouseMenu) {
				sortingMenu = false;
			}
		}, 500);
	}

	const onButtonMouseLeave = () => {
		mouseButton = false;
		closeMenu();
	}

	const onMenuMouseEnter = () => {
		mouseMenu = true;
		hideTimeout = null;
	};

	const onMenuMouseLeave = () => {
		mouseMenu = false;
		closeMenu();
	};
</script>


<section>
	<h1 class="title">
		{$t("news.title")}
	</h1>
	<div class="content">
		<div class="filters">
			<div class="left-side">
				<div class="categories">
					{#each categories as category, index }
						{#if category.type === "news"}
							<button class="btn category" on:click={() => filterButton(index)} class:active={activeCategory === index}>
								{category.name}
							</button>
						{/if}
					{/each}
				</div>
				<div class="search">
					<form on:submit|preventDefault>
						<label for="search_news" class="input_search">
							<img src={SearchImage} alt="Search">
							<input type="text" name="search_news" id="search_news" placeholder="{$t('news.search')}" bind:value={searchQuery}>
						</label>
					</form>
				</div>
			</div>
			<div class="right-side">
				<div class="sorting">
					<div class="menu" class:opened={sortingMenu} on:mouseenter={onMenuMouseEnter} on:mouseleave={onMenuMouseLeave} role="menu" aria-hidden={!sortingMenu}>
						<div class="filters-wrapper">
							<div class="filter" class:checked={activeFilter === 0}>
								<button class="btn" on:click={() => activeFilter = 0}>
									{$t('news.sorting_new_date')}
									<img src={Check} alt="Check">
								</button>
							</div>
							<div class="filter" class:checked={activeFilter === 1}>
								<button class="btn" on:click={() => activeFilter = 1}>
									{$t('news.sorting_old_date')}
									<img src={Check} alt="Check">
								</button>
							</div>
						</div>
					</div>
					<div class="button">
						<button class="btn sorting-btn" on:mouseenter={onButtonMouseEnter} on:mouseleave={onButtonMouseLeave}><img src={SortingImage} alt="Sorting"></button>
					</div>
				</div>
			</div>
		</div>
		<div class="articles">
			{#each sortedArticles as article }
				<Article data={article}/>
			{/each}
		</div>
	</div>
</section>

<style lang="scss">
	@import "/src/lib/scss/main";

	section	{
		margin-top: 125px;
		display: flex;
		flex-direction: column;
		gap: 50px;
		margin-bottom: 80px;

		& > .title {
			font-style: italic;
			font-weight: 800;
			font-size: 45px;
			line-height: 93%;
			color: #fff;
			text-transform: uppercase;
		}

		& > .content {
			display: flex;
			flex-direction: column;
			gap: 70px;

			& > .filters {
				display: flex;
				align-items: center;
				justify-content: space-between;

				& > .left-side {
					display: flex;
					align-items: center;
					gap: 45px;

					& > .categories {
						display: flex;
						align-items: center;
						gap: 10px;

						& > .category {
							width: 130px;
							height: 33px;
							border-radius: 4px;
							background: rgba(62, 62, 62, 0.6);
							font-size: 15px;
							font-weight: 400;
							text-transform: uppercase;
							font-style: italic;
							transition: font-weight, $default-transition-time, background-color $default-transition-time, color $default-transition-time;
							user-select: none;

							&.active {
								background-color: #fed501;
								font-weight: 800;
								color: #232323;
							}
						}
					}

					& > .search {

						& > form {

							& > .input_search {
								display: flex;
								gap: 18px;
								align-items: center;
								width: 200px;
								height: 30px;
								border-bottom: 1px solid rgba(255, 255, 255, 0.3);
								padding-bottom: 5px;

								& > input {
									background: none;
									border: none;
									font-size: 12pt;
									outline: none;
									width: 100%;
									color: white;
									font-family: $font-family;
									user-select: none;
								}

								& > img {
									display: flex;
									width: 20px;
									height: 20px;
									user-select: none;
								}
							}
						}
					}
				}

				& > .right-side {

					& > .sorting {
						display: flex;
						align-items: center;
						position: relative;

						& > .menu {
							background-color: #232323;
							transition: transform 0.4s;
							position: absolute;
							right: 40px;
							top: 30px;
							z-index: 10;
							border-radius: 14px;
							width: max-content;
							padding: 20px;
							transform: scale(0);

							& > .filters-wrapper {
								display: flex;
								flex-direction: column;
								gap: 20px;

								& > .filter {
									display: flex;
									align-items: center;
									gap: 20px;

									& > button {
										display: flex;
										align-items: center;
										gap: 10px;
										text-align: left;
										font-weight: 400;
										font-size: 14px;
									}

									& > button > img {
										opacity: 0;
										width: 24px;
										transition: opacity $default-transition-time;
									}

									&.checked {
										& > button {
											font-weight: 500;
										}

										& > button > img {
											opacity: 1;
										}
									}
								}
							}

							&.opened {
								transform: none;
							}
						}
					}
				}
			}
		}
	}

	.articles {
		display: grid;
		grid-template-columns: repeat(4, 300px);
		gap: 36px;
	}

	.sorting-btn {
		width: 34px;
		height: 34px;
		user-select: none;
	}

	@media screen and (max-width: 1500px) {
		.articles {
			grid-template-columns: repeat(3, 300px) !important;
		}
	}

	@media screen and (max-width: 1100px) {
		.articles {
			grid-template-columns: repeat(2, 1fr) !important;
			width: 636px!important;
		}
		.left-side {
			flex-direction: column!important;
			gap: 20px!important;
			align-items: flex-start!important;
		}
	}

	@media screen and (max-width: 750px) {
		.articles {
			grid-template-columns: repeat(1, 1fr) !important;
			width: 320px!important;
		}
		.categories {
			flex-direction: column!important;
		}
		.left-side {
			flex-direction: column!important;
			gap: 20px!important;
			align-items: flex-start!important;
		}
    }
</style>